<template>
    <CModal class="OrgGovProfilePreviewModal" @close="close">
        <div class="mt-6 text-center">
            <CHeading class="mb-6" variant="2">
                Ukážka typu profilu <strong class="uppercase text-primary-800 dark:text-primary-300">{{ levelLabel }}</strong>
            </CHeading>

            <img
                :alt="`Ukážka typu profilu ${levelLabel}`"
                class="h-auto w-full max-w-[600px] rounded shadow"
                :src="imgSrc"
            />
        </div>

        <template v-if="!preview" #footer>
            <div class="text-center">
                <CButton class="w-1/2 uppercase" size="large" variant="success" @click="onConfirm"> Vybrať </CButton>
            </div>
        </template>
    </CModal>
</template>

<script lang="ts">
import { orgGovPaidProfileLevelDictionary } from '#shared/types/dictionary'
import type { OrgGovPaidProfileLevel } from '#shared/types/Org'
import CButton from '@/components/ui/CButton.vue'
import CHeading from '@/components/ui/CHeading.vue'
import CModal from '@/components/ui/CModal.vue'
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'OrgGovProfilePreviewModal',

    components: {
        CButton,
        CHeading,
        CModal
    },

    props: {
        level: {
            type: String as PropType<OrgGovPaidProfileLevel | null>,
            default: null
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close'],

    setup(props, { emit }) {
        const levelLabel = computed(() => {
            return props.level ? orgGovPaidProfileLevelDictionary[props.level] : 'FREE'
        })

        const imgSrc = computed(() => {
            try {
                return new URL(
                    `../../../assets/images/org-gov-previews/org-gov-${props.level || 'free'}.png`,
                    import.meta.url
                ).href
            } catch {
                return ''
            }
        })

        function onConfirm() {
            close(true)
        }

        function close(value = false) {
            emit('close', value)
        }

        return {
            levelLabel,
            imgSrc,
            onConfirm,
            close
        }
    }
})
</script>
